import { DateInput } from "@monsterindia/global-ui-components";
import React, { memo } from "react";
import { Controller } from "react-hook-form";

import { DateControllerProps } from "./dateController.types";

const DateController = ({
  name,
  control,
  isRequired = true,
  placeholder,
  onDateSelect,
  minDate,
  errorMessage,
}: DateControllerProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={isRequired ? { required: "This field is required" } : undefined}
      render={({ field }) => {
        return (
          <DateInput
            value={field.value}
            onDateSelect={(date: string) => {
              field.onChange(date);
              onDateSelect(date);
            }}
            placeholder={placeholder}
            min={minDate}
            errorText={errorMessage}
          />
        );
      }}
    />
  );
};

export default memo(DateController);
